import React from 'react';
import KYCLevelComponent from 'apex-web/lib/components/KYC/KYCLevel';
import {
  getLevel1VerificationProps,
  getLevel2VerificationProps
} from './helpers';

const KYCLevelsComponent = props => {
  const {
    highlightStyle,
    levels,
    levelIncreaseStatus,
    verificationLevel,
    userEmail
  } = props;

  return levels.map(level => {
    if (level.level === 0) {
      const levelProps = getLevel1VerificationProps(
        verificationLevel,
        levelIncreaseStatus
      );

      return (
        <KYCLevelComponent
          key={level.level}
          verified={true}
          config={level}
          {...levelProps}
          highlightStyle={highlightStyle}
        />
      );
    }

    const level1Props = getLevel2VerificationProps(
      verificationLevel,
      levelIncreaseStatus
    );

    const levelTitle = level1Props.verified
      ? verificationLevel >= 1 && verificationLevel <= 4
        ? 'KYC'
        : verificationLevel >= 5 && verificationLevel <= 8
          ? 'KYB'
          : 'Retirement account'
      : null;

    const updatedLevel = {
      level: 1,
      label: level1Props.verified ? levelTitle : 'KYC/KYB',
      description: {
        benefits: [],
        requirements: 'Verify personal information.'
      },
      verifiedMessage: `Verified for ${levelTitle}`,
      underReviewMessage: 'Application under review. Check back later.',
      steps: []
    };

    return (
      <KYCLevelComponent
        key={level.level}
        config={updatedLevel}
        {...level1Props}
        openPane={() => {
          window.open(
            `${
              process.env.REACT_APP_NOMIX_AUTH_URL
            }/onboarding?email=${userEmail}`,
            '_blank'
          );
        }}
        highlightStyle={highlightStyle}
      />
    );
  });
};

export default KYCLevelsComponent;
